import {Component, Inject, } from '@angular/core';
import {MD_DIALOG_DATA, MdDialogRef} from '@angular/material';
import {DeleteItemDialogComponent} from '../delete-item-dialog/delete-item-dialog.component';

@Component({
  selector: 'app-restore-item-dialog',
  templateUrl: './restore-item-dialog.component.html',
  styleUrls: ['./restore-item-dialog.component.scss']
})
export class RestoreItemDialogComponent {

    constructor(public dialogRef: MdDialogRef<DeleteItemDialogComponent>,
                @Inject(MD_DIALOG_DATA) public data: any) {
    }

    /**
     * Closes the form and returns the ID of the item to be deleted
     */
    onSubmit() {
        this.dialogRef.close(this.data.id);
    }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/utilities/components/restore-item-dialog/restore-item-dialog.component.ts